<template>
  <main-layout :selectedMenu="'home'">
    <div class="do-competition contantGeek" v-if="language==='zh'">
      <div class="geekBoxs">
        <div class="geekBanner">
          <div class="do-banner">
            <img src="/static/geekBanner.jpg" alt />
          </div>
          <div class="rightNavList">
            <ul>
              <li>
                <router-link :to="{name: 'presentfuture', params: {matchId:matchId}}">
                  <a href>
                    {{$t('global.首页')}}
                    <img src="/static/geeknext.png" alt />
                  </a>
                </router-link>
              </li>
              <li>
                <router-link :to="{name: 'awards', params: {matchId:matchId,page:0}}">
                  {{$t('global.获奖公示')}}
                  <img src="/static/geeknext.png" alt />
                </router-link>
              </li>
              <li :class="{geekMenuActive:page ==0}" @click="page = 0">
                <router-link :to="{name: 'entries', params: {matchId:matchId,page:0}}">
                  {{$t('global.入围作品')}}
                  <img src="/static/geeknext.png" v-if="page != 0" />
                </router-link>
              </li>
              <li :class="{geekMenuActive:page ==1}" @click="page = 1">
                <router-link :to="{name: 'works', params: {matchId:matchId,page:1}}">
                  {{$t('global.参赛作品')}}
                  <img src="/static/geeknext.png" v-if="page != 1" />
                </router-link>
              </li>
              <li :class="{geekMenuActive:page ==2}" @click="page=2">
                <a>
                  {{$t('global.近期事件')}}
                  <img src="/static/geeknext.png" v-if="page != 2" />
                </a>
              </li>
            </ul>
          </div>
          <span
            @click="signGoTo"
            class="baroads"
            v-show="matchObject.status == 1"
          >{{$t('global.报名通道')}}</span>
          <a v-show="matchObject.status == 1" class="baroads unbaroads"></a>
        </div>

        <div class="geekVideo">
          <div class="videoLeft">
            <div class="geekTitle">{{$t('global.入围作品')}}</div>
            <div class="geekLine"></div>
            <div class="videoStart">
              <ul>
                <li class="noscale" v-for="item in homeVideolist" :key="item.videoId">
                  <router-link :to="'/video/detail?id='+item.videoId" target="_blank">
                    <img :src="item.videoThumb | imageUrl('',550,310)" />
                    <div class="blackLayers"></div>
                    <div class="blue"></div>
                  </router-link>

                  <div class="geekPersonal">
                    <router-link
                      class="spaned"
                      style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;"
                      :to="'/video/detail?id='+item.videoId"
                    >{{item.videoTitle}}</router-link>
                    <div class="geekHead">
                      <router-link :to="`/peopleCenter/`+item.userId">
                        <a class="geekheadSmall" href>
                          <img :src="item.userAvatar | imageUrl('/static/profile_img_default.png',40,40)" alt />
                        </a>
                        <span>
                          <a>{{item.userNickname}}</a>
                        </span>
                      </router-link>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div
              class="number search-number yyu"
              style="margin:0;margin-top: 15px;margin-bottom: -15px;"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="do-competition contantGeek" v-else>
      <div class="geekBoxs">
        <div class="geekBanner">
          <div class="do-banner">
            <img src="/static/geekBanner.jpg" alt />
          </div>
          <div class="rightNavList">
            <ul>
              <li>
                <router-link :to="{name: 'presentfuture', params: {matchId:matchId}}">
                  <a href>
                    Home
                    <img src="/static/geeknext.png" alt />
                  </a>
                </router-link>
              </li>
              <li>
                <router-link :to="{name: 'awards', params: {matchId:matchId,page:0}}">
                  Awards
                  <img src="/static/geeknext.png" alt />
                </router-link>
              </li>
              <li :class="{geekMenuActive:page ==0}" @click="page = 0">
                <router-link :to="{name: 'entries', params: {matchId:matchId,page:0}}">
                  Shortlisted
                  <img src="/static/geeknext.png" v-if="page != 0" />
                </router-link>
              </li>
              <li :class="{geekMenuActive:page ==1}" @click="page = 1">
                <router-link :to="{name: 'works', params: {matchId:matchId,page:1}}">
                  Exhibition
                  <img src="/static/geeknext.png" v-if="page != 1" />
                </router-link>
              </li>
              <li :class="{geekMenuActive:page ==2}" @click="page=2">
                <a>
                  Events
                  <img src="/static/geeknext.png" v-if="page != 2" />
                </a>
              </li>
            </ul>
          </div>
          <span @click="signGoTo" class="baroads" v-show="matchObject.status == 1">Sign up</span>
          <a v-show="matchObject.status == 1" class="baroads unbaroads"></a>
        </div>

        <div class="geekVideo">
          <div class="videoLeft">
            <div class="geekTitle">Shortlisted Entries</div>
            <div class="geekLine"></div>
            <div class="videoStart">
              <ul>
                <li class="noscale" v-for="item in homeVideolist" :key="item.videoId">
                  <router-link :to="'/video/detail?id='+item.videoId" target="_blank">
                    <img :src="item.videoThumb | imageUrl('',550,310)" />
                    <div class="blackLayers"></div>
                    <div class="blue"></div>
                  </router-link>

                  <div class="geekPersonal">
                    <router-link
                      class="spaned"
                      style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;"
                      :to="'/video/detail?id='+item.videoId"
                    >{{item.videoTitle}}</router-link>
                    <div class="geekHead">
                      <router-link :to="`/peopleCenter/`+item.userId">
                        <a class="geekheadSmall" href>
                          <img :src="item.userAvatar | imageUrl('/static/profile_img_default.png',40,40)" alt />
                        </a>
                        <span>
                          <a>{{item.userNickname}}</a>
                        </span>
                      </router-link>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div
              class="number search-number yyu"
              style="margin:0;margin-top: 15px;margin-bottom: -15px;"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <pages
      :page-size="pagerParam.pageSize"
      :page-count="pagerParam.pageCount"
      :current-page.sync="pagerParam.currentPage"
      :total="pagerParam.total"
      @current-page-changed="OnCurrentPageChanged"
    ></pages>
  </main-layout>
</template>

<script>
import "./css/lifePz.css";
import MainLayout from "@/layouts/MainLayout";
import pages from "../../components/pages.vue";

export default {
  name: "IndexPage",
  metaInfo() {
    return {
      title: this.$t("global.2019“现未来”科技艺术之星奖-入围作品") + " | MANA"
    };
  },
  components: {
    MainLayout,
    pages
  },
  data() {
    return {
      homeVideolist: [],
      pagerParam: {
        pageSize: 20,
        pageCount: 1,
        currentPage: 1,
        total: 1
      },
      matchId: -1,
      page: 1,
      matchObject: {},
      contestName: ""
    };
  },
  created() {
    this.page = this.$route.params.page;
    this.init();
  },
  computed: {
    language() {
      return this.$language();
    }
  },
  methods: {
    init() {
      this.contestName = "presentfuture";
      if (this.contestName) {
        this.$http
          .get("/api/nmatch/url/" + this.contestName)
          .then(response => {
            this.matchObject = response.data;
            this.gethomeVideolist();
          });
      }
    },
    gethomeVideolist() {
      let $this = this;
      this.$http
        .get("/api/match/video/list", {
          params: {
            matchId: this.matchObject.id,
            pageIndex: this.pagerParam.currentPage,
            pageSize: this.pagerParam.pageSize,
            status: 5
          }
        })
        .then(function(response) {
          if (response.code === "OK") {
            $this.homeVideolist = response.data.list;
            $this.pagerParam = {
              pageSize: response.data.pageSize,
              pageCount: response.data.totalPage,
              currentPage: response.data.pageIndex,
              total: response.data.totalRecord
            };
          }
        });
    },

    OnCurrentPageChanged(val) {
      this.pagerParam.currentPage = val;
      this.gethomeVideolist();
    },

    signGoTo() {
      debugger;
      if (!this.$store.state.peopleMessage) {
        this.$router.push("/login");
        return;
      }
      let $this = this;
      this.$http
        .post(
          "/api/match/user/checkIsMatch?userId=" +
            this.$store.state.peopleMessage.userId +
            "&matchId=" +
            this.matchId
        )
        .then(response => {
          debugger;
          if (response.code == 400) {
            $this.$router.push({ path: "/signupZ?matchId=" + this.matchId });
          } else {
            this.$router.push({ path: "/UpVideo?matchId=" + this.matchId });
          }
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/match/rwlifegeekhomePz.vue